import React, { useState } from 'react';
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging
} from 'devextreme-react/data-grid';
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import CustomStore from "devextreme/data/custom_store";
import { showToast } from "../../utils/Utils";
import { ToastType } from "../../constants/Constants";
import './PotansiyelTesvikSorgulama.scss';
import Box, {
    Item
} from 'devextreme-react/box';

const PotansiyelTesvikSorgulama = () => {

    const listeBasligi = "Potansiyel Teşvik Sorgulama";

    const [store, setStore] = useState(null);
    const [tcKimlikNo, setTcKimlikNo] = useState(null);
    const [aramaSonucu, setAramaSonucu] = useState(null);


    let dataGrid = null;

    const getStore = () => {
        let tempGrid = dataGrid;
        let currentTcKimlik = tcKimlikNo;

        return new CustomStore({
            key: 'donem',
            useDefaultSearch: false,
            load: function (loadOptions) {
                console.log("loadOptions", loadOptions);
                if (loadOptions.searchOperation == undefined) {
                    return;
                }

                // TC Kimlik numarası yoksa boş döndür
                if (!currentTcKimlik) {
                    return {
                        data: [],
                        totalCount: 0,
                        summary: 0,
                        groupCount: 0
                    };
                }

                const request = new Request(`/tesvikIslem/getRaporUcretHesapList/${currentTcKimlik}`, "GET");

                return request.run()
                    .then(response => {
                        if (response.data && response.data.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.data.length,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return {
                                data: [],
                                totalCount: 0,
                                summary: 0,
                                groupCount: 0
                            };
                        }
                    });
            }
        });
    }




    const tcKimlikAra = () => {
        if (!tcKimlikNo || tcKimlikNo.toString().length !== 11) {
            showToast('TC Kimlik numarası 11 haneli olmalıdır', ToastType.ERROR, 3000);
            return;
        }

        const request = new Request(`/tesvikIslem/getRaporUcretHesapList/${tcKimlikNo}`, "GET");
        
        return request.run()
            .then(response => {
                if (response.data && response.data.data) {
                    setAramaSonucu(response.data.data);
                    // Grid'i güncelle
                    setStore(getStore());
                } else {
                    setAramaSonucu([]);
                    setStore(null);
                    showToast('Sonuç bulunamadı', ToastType.INFO, 3000);
                }
            })
            .catch(error => {
                showToast('Arama sırasında bir hata oluştu', ToastType.ERROR, 3000);
                console.error('Arama hatası:', error);
            });
    }

    const onTcKimlikChanged = (e) => {
        setTcKimlikNo(e.value);
    }





    return (
        <React.Fragment>

            <h2 className={'dx-icon-product'}>{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px", marginBottom: "10px" }}>
                    <Box direction="row" width={850} height={35}> 
                        <Item ratio={0} baseSize={405}>
                            <div className="dx-field" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <div className="dx-field-label" style={{ width: '120px', marginRight: '5px' }}>TC Kimlik No</div>
                                <div className="dx-field-value" style={{ width: '150px', flex: '0 0 auto' }}>
                                    <TextBox 
                                        readOnly={false} 
                                        hoverStateEnabled={false} 
                                        value={tcKimlikNo}
                                        onValueChanged={onTcKimlikChanged}
                                        placeholder="11 haneli TC Kimlik No"
                                        maxLength={11}
                                    />
                                </div>
                            </div>
                        </Item>
                        <Item ratio={0} baseSize={10}></Item>
                        <Item ratio={0} baseSize={120}>
                            <Button 
                                icon="search" 
                                width={120} 
                                text="Ara" 
                                type={'default'} 
                                style={{ fontSize: "15px" }}
                                onClick={tcKimlikAra}
                            />
                        </Item>
                    </Box> 
                </div>
            </div>


            <DataGrid
                className="sgkIslemleriGrid"
                ref={ref => dataGrid = ref}
                style={{ padding: 5 }}
                width="100%"
                //height="100%"
                dataSource={store}
                key="donem"
                keyExpr="donem"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                repaintChangesOnly={true}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                //selection={{mode: 'multiple', deferred:true}}
                remoteOperations={false}
            >
                <FilterRow visible={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Paging defaultPageSize={12} />


                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} allowEditing={false} />
                <Column dataField={'personelTckNo'} width={100} caption={'Tc'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField={'personelAdi'} width={100} caption={'Adı'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField={'personelSoyadi'} width={100} caption={'Soyadı'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField={'domain'} width={100} caption={'Tc'} dataType="Firma" visible={true} allowEditing={false} />
                <Column dataField="donem" width={80} caption={'Dönem'} dataType="Dönem" visible={true} allowEditing={false} />
                <Column dataField="ucret" width={80} caption={'Ücret'} dataType="number" format={{ type: "fixedPoint", precision: 2 }} visible={true} allowEditing={false} />
                <Column dataField="ikramiye" width={80} caption={'ikramiye'} dataType="number" format={{ type: "fixedPoint", precision: 2 }} visible={true} allowEditing={false} />
                <Column dataField="toplam" width={80} caption={'toplam'} dataType="number" format={{ type: "fixedPoint", precision: 2 }} visible={true} allowEditing={false} />
                <Column dataField="gun" width={80} caption={'gun'} dataType="number" format={{ type: "fixedPoint", precision: 0 }} visible={true} allowEditing={false} />
                <Column dataField="ggun" width={80} caption={'ggun'} dataType="number" format={{ type: "fixedPoint", precision: 0 }} visible={true} allowEditing={false} />
                <Column dataField="cgun" width={80} caption={'cgun'} dataType="number" format={{ type: "fixedPoint", precision: 0 }} visible={true} allowEditing={false} />


            </DataGrid>


        </React.Fragment>
    );
}

export default PotansiyelTesvikSorgulama;

